import {
  FUNDED_SEARCH_PARAMS,
  IFundedOfferingsQueryVariables,
} from '@r-client/republic/data/offerings';

export const HEADING = 'Funded ventures';

export const SEE_ALL_HREF = '/funded-ventures';

export const EMPTY_MESSAGE = 'No funded ventures yet.';

/**
 * Must differ from the growth-stage skeleton's label: both sections sit on the
 * same page, and two `role="status"` regions sharing a name are ambiguous to
 * assistive tech and to `getByRole`.
 */
export const LOADING_LABEL = 'Loading funded ventures';

/** One rail-length of cards. The rail is not paginated. */
export const FUNDED_RAIL_PAGE_SIZE = 8;

/**
 * Module-level rather than built per render: `useQuery` re-runs
 * `setVariables` whenever the *identity* of this object changes, and nothing
 * here depends on props or state.
 */
export const FUNDED_QUERY_VARIABLES: IFundedOfferingsQueryVariables = {
  first: FUNDED_RAIL_PAGE_SIZE,
  searchParams: FUNDED_SEARCH_PARAMS,
};
